import useOnValueChange from "../../../hooks/useOnValueChange";
import { InputProps } from "../Calculator";
import NumberInput from "../../BuildingBlocks/NumberInput/NumberInput";

const TITLE = "מספר שנות השקעה";
const SUBTITLE = "כמה שנים יופקדו הכספים ברמה החודשית";
const NAME = "investment-years";

const InvestmentYears = ({ contextKey }: InputProps) => {
  const onValueChange = useOnValueChange(contextKey);
  return (
    <NumberInput
      title={TITLE}
      placeholder={SUBTITLE}
      name={NAME}
      onlyPositive
      onChange={(value: number) => onValueChange(value)}
    />
  );
};

export default InvestmentYears;
